// extracted by mini-css-extract-plugin
export default {"component":"Staking_component__9sKJ-"};